import api from "../api";

export function getGalleries() {
    return api.get('/dashboard/galleries/all');
}

export function createGallery(formData: FormData) {
    return api.post('/dashboard/galleries/create', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export function deleteGallery(id: number) {
    return api.post(`/dashboard/galleries/delete/${id}`);
}

export function getGalleryById(id: number) {
    return api.get(`/dashboard/galleries/fetch-single/${id}`);
}

export function editGallery(formData: FormData, id: number) {
    return api.post(`/dashboard/galleries/update/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}
